import { render, staticRenderFns } from "./WorstsModal.vue?vue&type=template&id=4b7ed8ca&scoped=true&"
import script from "./WorstsModal.vue?vue&type=script&lang=js&"
export * from "./WorstsModal.vue?vue&type=script&lang=js&"
import style0 from "./WorstsModal.vue?vue&type=style&index=0&id=4b7ed8ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7ed8ca",
  null
  
)

export default component.exports